import axios from "axios";

const BASE = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api/mobile/driver`;
const RUNTIME = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api/mobile/runtime`;

const native = () => window.VoorNative || null;

export const driverSession = {
  get() {
    try {
      return native()?.getDriverToken?.() || sessionStorage.getItem("vb_driver_token") || "";
    } catch {
      return sessionStorage.getItem("vb_driver_token") || "";
    }
  },
  set(token) {
    sessionStorage.setItem("vb_driver_token", token);
    try { native()?.storeDriverToken?.(token); } catch { /* web fallback */ }
  },
  clear() {
    sessionStorage.removeItem("vb_driver_token");
    try { native()?.clearDriverToken?.(); } catch { /* web fallback */ }
  },
};

const client = axios.create({ baseURL: BASE, timeout: 20000, withCredentials: false });
client.interceptors.request.use((config) => {
  const token = driverSession.get();
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-VOOR-Platform"] = native() ? "android" : "web";
  config.headers["X-VOOR-App-Version"] = "1.1.0";
  return config;
});

export const driverApi = {
  login: (username, password) => client.post("/login", { username, password }).then((r) => r.data),
  logout: () => client.post("/logout").then((r) => r.data),
  me: () => client.get("/me").then((r) => r.data),
  offers: (after = "") => client.get("/offers", { params: { after, limit: 25 } }).then((r) => r.data),
  offer: (id) => client.get(`/offers/${encodeURIComponent(id)}`).then((r) => r.data),
  acceptOffer: (id, review_token) => client.post(`/offers/${encodeURIComponent(id)}/accept`, { review_token }).then((r) => r.data),
  weeklyHistory: (cursor = "") => client.get("/history/weekly", { params: { cursor, limit: 25 } }).then((r) => r.data),
  trips: () => client.get("/trips", { params: { limit: 100 } }).then((r) => r.data),
  trip: (id) => client.get(`/trips/${id}`).then((r) => r.data),
  action: (id, action) => client.post(`/trips/${id}/actions/${action}`).then((r) => r.data),
  availability: (state) => client.put("/availability", { state }).then((r) => r.data),
  location: (payload) => client.post("/location", payload).then((r) => r.data),
  registerDevice: (payload) => axios.post(`${RUNTIME}/driver/device`, payload, {
    timeout: 20000,
    withCredentials: false,
    headers: { Authorization: `Bearer ${driverSession.get()}` },
  }).then((r) => r.data),
};

export const nativeDriver = {
  available: () => Boolean(native()),
  startTracking: (tripId) => native()?.startDriverTracking?.(driverSession.get(), tripId),
  stopTracking: () => native()?.stopDriverTracking?.(),
  openDirections: (lat, lng) => native()?.openDirections?.(String(lat), String(lng)),
};
